import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import {
  Form,
  Dropdown, DropdownMenu, DropdownToggle, Label,
} from 'reactstrap';
import Isvg from 'react-inlinesvg';

import Checkbox from 'app/components/general/Checkbox';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';

import FilterIcon from 'app/images/icons/filter.svg';

interface IProps {
  title: string;
  handleFilterChange: Function;
  handleFilterToggleChange: Function;
  handleFilterMenuOpen: Function;
  clearFilters: Function;
  applyFilters: Function;
  filterOptions: any;
  filterConfig: any;
  persistentFilterConfig: any;
  selectedOptions: any;
}

const TableFilter: FC<IProps> = (props: IProps = {
  title: undefined,
  handleFilterChange: undefined,
  handleFilterToggleChange: undefined,
  handleFilterMenuOpen: undefined,
  clearFilters: undefined,
  applyFilters: undefined,
  filterOptions: [],
  filterConfig: {},
  persistentFilterConfig: {},
  selectedOptions: {},
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = (e): void => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    props.handleFilterMenuOpen(dropdownOpen);
  }, [dropdownOpen]);

  const handleSubmit = (): void => {
    setDropdownOpen(false);
    props.applyFilters();
  };

  const handleClear = (): void => {
    setDropdownOpen(false);
    props.clearFilters();
  };

  const renderMenuOptions = (): React.ReactNode => _.map(props.filterOptions, (option) => {
    const value = option.type === 'select'
      ? props.filterConfig[option.accessor] || []
      : props.filterConfig[option.accessor] || '';
    return (
      <div key={option.accessor}>
        <div className="dropdown-item-filter">
          <div className="w-100">
            <Checkbox
              onClick={() => props.handleFilterToggleChange(option.accessor)}
              checked={props.selectedOptions[option.accessor]}
            />
            <Label className="d-inline">{option.label}</Label>
          </div>
          {props.selectedOptions[option.accessor] === true && (
            <div className="w-100 with-margin-top-5">
              <InputGroupBlock
                type={option.type}
                inputGroupClassName="no-margin-bottom"
                className="height-40"
                labelText={null}
                name={option.accessor}
                placeholder={option.label}
                aria-label={option.label}
                autoComplete="off"
                autoFocus
                createable
                clearable
                isMulti={option.isMulti}
                mode="range"
                options={option.options}
                value={value}
                onChange={(e, name, type) => props.handleFilterChange(e, name, type)}
              />
            </div>
          )}
        </div>
      </div>
    );
  });

  const renderDropdown = (): React.ReactNode => (
    <DropdownMenu
      data-focus="false"
    >
      <div className="dropdown-item-header">{props.title}</div>
      <Form onSubmit={handleSubmit}>
        {renderMenuOptions()}
        <div className="dropdown-buttons">
          <div className="filter-btn-container">
            <Button
              onClick={handleClear}
              type="button"
              className="btn-thinner btn-2 float-left"
            >
              Clear
            </Button>
            <Button
              className="btn-thinner btn-1"
              type="submit"
              loadingText="Filtering"
            >
              Apply
            </Button>
          </div>
        </div>
      </Form>
    </DropdownMenu>
  );

  const persistentFilterNumber = _.isEmpty(props.persistentFilterConfig)
    ? 0
    : Object.keys(props.persistentFilterConfig).length;

  const filterNumber = _.isEmpty(props.filterConfig) ? 0 : Object.keys(props.filterConfig).length - persistentFilterNumber;
  const parsedFilterNumber = filterNumber <= 0 ? null : `(${filterNumber})`;

  return (
    <Dropdown direction="right" isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        tag="button"
        className={classnames('btn btn-thinner btn-2 dropdown-btn', {
          active: filterNumber != null,
        })}
        data-toggle="dropdown"
        data-focus="false"
        aria-expanded={dropdownOpen}
      >
        <Isvg className="btn-icon" src={FilterIcon} />
        Filter
        {' '}
        {parsedFilterNumber}
      </DropdownToggle>
      {renderDropdown()}
    </Dropdown>
  );
};
export default TableFilter;
